export enum MediaProtectionStatus {
    HIDDEN = "1",
    VISIBLE = "2",
}
